"use strict";

exports.__esModule = true;
exports.AddPartCountDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core/");
var _DeviceContext = require("../../Device/DeviceContext");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _Time = require("../../Time");
var _Timeline = require("../../Timeline");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _BadPartCount = require("./BadPartCount");
var _GoodPartCount = require("./GoodPartCount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AddDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "AddPartCountDialog__AddDialog",
  componentId: "sc-13ywab6-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var NumberInputGroup = (0, _styledComponents["default"])(_core.InputGroup).withConfig({
  displayName: "AddPartCountDialog__NumberInputGroup",
  componentId: "sc-13ywab6-1"
})([".", "{width:100px;text-align:center;}"], _core.Classes.INPUT);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__DialogBodySection",
  componentId: "sc-13ywab6-2"
})(["margin:1rem 1rem 0 1rem;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__Row",
  componentId: "sc-13ywab6-3"
})(["display:flex;padding:0.8rem 0;border-top 1px solid rgba(0,0,0,0.1);"]);
var PartsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__PartsWrapper",
  componentId: "sc-13ywab6-4"
})(["display:flex;flex-direction:column;flex:1;justify-content:center;"]);
var FormWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__FormWrapper",
  componentId: "sc-13ywab6-5"
})(["display:flex;flex-direction:column;flex:2;"]);
var PartKind = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__PartKind",
  componentId: "sc-13ywab6-6"
})(["margin-bottom:1rem;font-weight:bold;"]);
var ErrorMessage = _styledComponents["default"].div.withConfig({
  displayName: "AddPartCountDialog__ErrorMessage",
  componentId: "sc-13ywab6-7"
})(["float:left;font-style:italic;"]);

/**
 * A dialog to increment partkind
 */

var AddPartCountDialog = exports.AddPartCountDialog = function AddPartCountDialog(props) {
  var label = props.label;
  var _useState = (0, _react.useState)(0),
    goodPartCount = _useState[0],
    setGoodPartCount = _useState[1];
  var _useState2 = (0, _react.useState)(0),
    badPartCount = _useState2[0],
    setBadPartCount = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    isAddingPartCount = _useState3[0],
    setIsAddingPartCount = _useState3[1];
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    getBadProcessCount = _React$useContext.getBadProcessCount,
    getGoodProcessCount = _React$useContext.getGoodProcessCount;
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  var increaseGoodPartCount = function increaseGoodPartCount() {
    setGoodPartCount(goodPartCount + 1);
  };
  var decreaseGoodPartCount = function decreaseGoodPartCount() {
    if (goodPartCount > 0) {
      setGoodPartCount(goodPartCount - 1);
    }
  };
  var increaseBadPartCount = function increaseBadPartCount() {
    setBadPartCount(badPartCount + 1);
  };
  var decreaseBadPartCount = function decreaseBadPartCount() {
    if (badPartCount > 0) {
      setBadPartCount(badPartCount - 1);
    }
  };
  var onChangeGoodPartCount = function onChangeGoodPartCount(e) {
    var count = parseInt(e.target.value, 10);
    if (Number.isInteger(count) && count >= 0) {
      setGoodPartCount(count);
    }
    if (e.target.value === "") {
      setGoodPartCount(0);
    }
  };
  var onChangeBadPartCount = function onChangeBadPartCount(e) {
    var count = parseInt(e.target.value, 10);
    if (Number.isInteger(count) && count >= 0) {
      setBadPartCount(count);
    }
    if (e.target.value === "") {
      setBadPartCount(0);
    }
  };
  var onClose = function onClose() {
    props.toggleDialog();
    setGoodPartCount(0);
    setBadPartCount(0);
  };
  var onClosed = function onClosed() {
    setGoodPartCount(0);
    setBadPartCount(0);
  };
  var submitValues = function submitValues(partKind) {
    var goodParts = {
      input_type: "process-count",
      device_uuid: device && device.uuid,
      quality: "good",
      part_kind: partKind,
      part_count: goodPartCount
    };
    var badParts = {
      input_type: "process-count",
      device_uuid: device && device.uuid,
      quality: "bad",
      part_kind: partKind,
      part_count: badPartCount
    };
    setIsAddingPartCount(true);
    setTimeout(function () {
      props.onSubmit({
        goodParts: goodParts,
        badParts: badParts
      });
      setGoodPartCount(0);
      setBadPartCount(0);
      setIsAddingPartCount(false);
    }, 4000);
  };
  return /*#__PURE__*/_react["default"].createElement(AddDialog, {
    icon: _icons.IconNames.COG,
    isOpen: props.isOpen,
    onClose: onClose,
    onClosed: onClosed,
    title: label
  }, /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
    defaultValue: null,
    timelineName: _Timeline.TIME_SERIES_KIND,
    query: {
      device: device ? device.uuid : undefined
    },
    isCurrent: true
  }, function (packet) {
    var partKind = packet && packet.value && packet.value.part_kind;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(PartKind, null, translate("AddPartCountDialog.partKindValue.title", "Part Kind: {partKind}", {
      partKind: partKind || "-"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(PartsWrapper, null, /*#__PURE__*/_react["default"].createElement(_GoodPartCount.GoodPartCount, {
      device: device,
      reportingPeriod: reportingPeriod,
      partKind: partKind,
      getGoodProcessCount: getGoodProcessCount
    })), /*#__PURE__*/_react["default"].createElement(FormWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !partKind,
      large: true,
      onClick: decreaseGoodPartCount,
      icon: _icons.IconNames.MINUS
    }), /*#__PURE__*/_react["default"].createElement(NumberInputGroup, {
      disabled: !partKind,
      large: true,
      onChange: onChangeGoodPartCount,
      value: goodPartCount
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !partKind,
      large: true,
      onClick: increaseGoodPartCount,
      "data-testid": "add-good-part-count",
      icon: _icons.IconNames.PLUS
    }))))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(PartsWrapper, null, /*#__PURE__*/_react["default"].createElement(_BadPartCount.BadPartCount, {
      device: device,
      reportingPeriod: reportingPeriod,
      partKind: partKind,
      getBadProcessCount: getBadProcessCount
    })), /*#__PURE__*/_react["default"].createElement(FormWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !partKind,
      large: true,
      onClick: function onClick() {
        return decreaseBadPartCount();
      },
      icon: _icons.IconNames.MINUS
    }), /*#__PURE__*/_react["default"].createElement(NumberInputGroup, {
      large: true,
      disabled: !partKind,
      onChange: onChangeBadPartCount,
      value: badPartCount
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !partKind,
      large: true,
      onClick: increaseBadPartCount,
      icon: _icons.IconNames.PLUS
    })))))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _core.Classes.DIALOG_FOOTER
    }, !partKind && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, translate("AddPartCountDialog.errorMessage.text", "Enter part kind to add count")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER_ACTIONS
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !partKind,
      loading: isAddingPartCount,
      intent: _core.Intent.PRIMARY,
      "data-testid": "submit-add-part-count",
      onClick: function onClick() {
        return submitValues(partKind || "");
      },
      text: translate("AddPartCountDialog.add.text", "Add")
    }))));
  }));
};